const WhatsAppFab = () => (
  <a
    href="https://wa.me/5491127790411?text=Hola%2C%20me%20interesa%20el%20servicio%20de%20fibra%20%C3%B3ptica"
    target="_blank"
    rel="noreferrer"
    data-testid="whatsapp-fab"
    className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#22c55e] text-white shadow-[0_10px_30px_rgba(34,197,94,0.45)] transition-transform hover:scale-110"
    aria-label="Chat por WhatsApp"
  >
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      className="h-7 w-7"
      aria-hidden="true"
    >
      <path d="M20.52 3.48A11.94 11.94 0 0012.03 0C5.45 0 .13 5.32.13 11.9c0 2.1.55 4.15 1.6 5.95L0 24l6.32-1.66a11.9 11.9 0 005.7 1.45h.01c6.58 0 11.9-5.33 11.9-11.9 0-3.18-1.24-6.17-3.41-8.41zM12.03 21.6h-.01a9.67 9.67 0 01-4.93-1.35l-.35-.21-3.75.98 1-3.66-.23-.37a9.68 9.68 0 01-1.48-5.1C2.28 6.53 6.65 2.17 12.03 2.17a9.65 9.65 0 016.87 2.85 9.65 9.65 0 012.85 6.88c0 5.38-4.37 9.7-9.72 9.7zm5.56-7.28c-.3-.15-1.8-.88-2.08-.98-.28-.1-.48-.15-.68.15-.2.3-.78.98-.96 1.18-.18.2-.36.22-.66.08-.3-.15-1.27-.47-2.42-1.5-.9-.8-1.5-1.79-1.68-2.09-.18-.3-.02-.46.13-.61.14-.13.3-.35.45-.53.15-.18.2-.3.3-.5.1-.2.05-.38-.03-.53-.08-.15-.68-1.63-.93-2.23-.24-.58-.5-.5-.68-.51l-.58-.01c-.2 0-.52.08-.8.38s-1.04 1.02-1.04 2.49 1.07 2.89 1.22 3.09c.15.2 2.1 3.2 5.09 4.49.71.31 1.27.49 1.7.63.71.23 1.36.2 1.87.12.57-.08 1.8-.73 2.05-1.43.25-.7.25-1.3.18-1.43-.08-.14-.28-.22-.58-.37z" />
    </svg>
  </a>
);

export default WhatsAppFab;
